import React from "react";
import PageLayout from "../../components/PageLayout";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  return (
    <div className="policyes legal">
      <PageLayout>
        <div className="container">
          <h2 className="titletwo">
            Terms of <span>Service</span>
          </h2>
          <p>
            Paths app by Seize LLC
            <br /> Terms of Use
            <br /> Last Updated: January 1, 2025
          </p>

          <p>
            Please read these Terms of Use carefully before you start to use our
            website or mobile application. By using Seize LLC’s (the “Company,”
            we,” “us,” “our”) getpaths.com website or mobile application
            (collectively, the “Site”), you agree to be bound by all terms,
            conditions, and notices contained or referenced herein (the
            “Terms”). If you do not agree to the Terms, do not access, download,
            or use the Site.
          </p>
          <p>
            The Terms, the Privacy Policy, and all other documents referenced
            herein govern the relationship between you, the Site user (“you”),
            and the Company with respect to your use of the Site. You agree that
            the agreement formed by the Terms is binding like any written,
            negotiated agreement signed by you, and you agree to be bound by,
            and fully comply with its terms. You represent and warrant that you
            have all necessary right, power, and authority to enter into this
            agreement and to perform and otherwise discharge all of your
            obligations hereunder.
          </p>
          <h5>USER ACCOUNTS AND GENERAL TERMS</h5>
          <p>
            In order to access and use the Site, you must create an account
            (“Account”) with us. You can create an Account by using your email
            address and creating a password. You may not register more than one
            (1) account, unless the Company authorizes you to do so. If you are
            under the age of eighteen (18), you may not use the Site. You also
            may not transfer or assign your account to another party.
          </p>
          <p>
            You agree at all times to: (i) provide accurate, current, and
            complete information about yourself during the registration process;
            and (ii) maintain and update your information (including your e-mail
            address) to keep it accurate, current, and complete. You acknowledge
            that, if any information provided by you is untrue, inaccurate, not
            current, or incomplete, we may, in our sole discretion, terminate
            your Account and your ability to use the Site, and report you to the
            appropriate authorities.
          </p>
          <p>
            You acknowledge and agree that we may send you information and
            notices regarding the Site by email or through other means. You
            acknowledge and agree that we shall have no liability associated
            with or arising from your failure to maintain accurate contact or
            other information, including, but not limited to, your failure to
            receive critical information about the Site.
          </p>
          <p>
            You are responsible for maintaining the confidentiality of your
            Account and password, and for restricting access to your device(s),
            and you agree to accept responsibility for all activities that occur
            on your Account. You shall not impersonate any person or entity or
            falsely state or otherwise misrepresent your identity or affiliation
            with a person or entity. You agree to immediately notify us of any
            unauthorized use, theft, or misappropriation of your Account,
            username, or password, or any other breach of security of which you
            become aware.
          </p>
          <p>
            All of the information you provide to us or that we collect from you
            in connection with your use of the Site will be governed by the
            Terms and our Privacy Policy. We reserve the right to change,
            remove, alter, or delete any username at any time and for any reason
            in our sole discretion. We further reserve the right to refuse
            service, remove or edit content, or cancel service requests in our
            sole discretion.
          </p>
          <p>
            You acknowledge and agree that the Company is not responsible for
            the conduct of users in interactive areas of the Site.
          </p>

          <h5>USER LICENSE</h5>
          <p>
            The Company grants you a limited, non-exclusive, non-sublicensable,
            revocable, non-transferable license to access and make use of the
            Site. Except as we may expressly authorize, you shall not (i)
            modify, copy, duplicate, distribute, redistribute, display, perform,
            reproduce, publish, license, transfer, sell, resell, share, make
            available to any third party, create derivative works based on, or
            otherwise exploit the Site; (ii) frame or mirror any Company
            Materials, Intellectual Property or content forming part of the
            Site; (iii) reverse engineer the Site; or (iv) access the Site in
            order to (a) build a competitive product or service, or (b) copy any
            ideas, features, functions or graphics of the Site. You may only use
            Company Materials and Intellectual Property on the Site as expressly
            permitted in the Terms and for no other purpose. Any unauthorized
            use of the Site shall automatically terminate the license granted to
            you by the Company for such use.
          </p>
          <h5>INTELLECTUAL PROPERTY</h5>
          <p>
            The Company may make certain content, software, or other electronic
            materials (including all files, text, URLs, video, audio, and images
            contained in or generated by such materials, and accompanying data)
            (collectively, “Company Materials”) available to you from the Site,
            from time to time. You acknowledge that the Site and other
            functionality and Company Materials available on the Site are
            protected by copyrights, trademarks, service marks, patents, trade
            secrets, laws related to internet domain names, and/or other
            proprietary rights (collectively, “Intellectual Property”) and are
            owned by the Company or are used by permission. We retain full and
            complete title to the Company Materials and Intellectual Property.
          </p>
          <p>
            You may download or print copies of portions of the materials on the
            Site, provided that you only use such copies for your own
            non-commercial use and do not modify or alter these copies in any
            way, or delete or change any copyright, trademark, or patent notices
            therein. No right, title, or interest in any Company Materials or
            Intellectual Property is transferred to you.
          </p>
          <p>
            The PATHS word trademark and logos, and other names and logos used
            to brand the Company’s products and services referenced herein, are
            trademarks and service marks of the Company. All other products,
            services, and company names mentioned herein are the trademarks and
            service marks of their respective owners. You may not copy, imitate,
            modify, or use the Company trademarks without our prior written
            consent. In addition, all page headers, custom graphics, button
            icons, and scripts are copyrights, service marks, trademarks, and/or
            trade dress of the Company and are the Company’s Intellectual
            Property. You may not copy, imitate, modify, or use these page
            headers, custom graphics, button icons, and scripts without our
            prior written consent. You may use HTML logos provided by us for the
            purpose of directing web traffic to the Company’s services. You may
            not alter, modify, or change these HTML logos in any way, use these
            HTML logos in a manner that mischaracterizes the Company or the
            Company’s services, and you may not display these HTML logos in any
            manner that implies the Company’s sponsorship or endorsement.
          </p>
          <p>
            All rights not expressly granted herein are reserved by the Company.
            Any unauthorized use of Company Materials or Intellectual Property
            appearing on the Site may violate copyright, trademark, and other
            applicable laws, and could result in criminal or civil penalties.
          </p>
          <h5>USER MATERIALS</h5>
          <p>
            The content and materials on the Site are largely generated by
            users. The Company welcomes you to use the Site to post, upload,
            display, perform, transmit or otherwise distribute appropriate
            information, materials, or other content at your direction,
            including photographs, video materials, posts, comments, opinions,
            or other content (collectively, “User Materials”), subject to the
            Terms.
          </p>
          <p>
            By posting User Materials to the Site, you represent and warrant
            that you have all right, title and interest necessary to post such
            User Materials and are fully authorized to make all authorizations,
            licenses, and/or warrantees that are made herein. By posting User
            Materials to the Site, you hereby grant the Company an unlimited,
            royalty-free, non-terminable, non-exclusive, irrevocable, perpetual,
            sublicensable, worldwide license to use, copy, reproduce, publish,
            adapt, modify, distribute, prepare derivative works based on,
            license, sell, offer for sale, transfer, publicly display, publicly
            perform, transmit, broadcast, and otherwise exploit and use (for any
            purpose whatsoever and in any form or medium whatsoever) your User
            Materials, including any and all copyrights, patents, publicity
            rights and privacy rights therein, by and on behalf of the Company
            without compensation for any purpose on any medium, whether printed,
            digital or otherwise.
          </p>
          <p>
            You agree that the Company may publish or otherwise disclose your
            name or username in connection with your User Materials. By posting
            User Materials on the Site, you warrant and represent that you own
            the rights to the User Materials or are otherwise authorized to
            post, distribute, display, perform, transmit, or otherwise
            distribute User Materials and that such User Materials do not
            violate any applicable laws, contractual restrictions, or any rights
            of third parties, including but not limited to intellectual property
            rights. You agree that the burden of proving that any User Materials
            do not violate any laws or third-party rights rests solely with you.
            By submitting any User Materials, you represent and warrant that
            such submissions are accurate, complete, and current. You agree that
            the User Materials are not confidential and no confidential
            relationship is established with the Company.
          </p>
          <p>
            You are solely responsible for your User Materials, including making
            and keeping backup copies of your User Materials and for applying
            the appropriate level of access rights to the same. The Company
            shall not be responsible or liable for the deletion or accuracy of
            any User Materials, the failure to store, transmit, encrypt (or
            otherwise secure) or receive any User Materials, or the storage,
            transmission, encryption (or other security) or receipt of any other
            communication involving the use of the Site.
          </p>
          <h5>CONTENT STANDARDS</h5>
          <p>
            All access and use of the Site and related services, including but
            not limited to the submission of User Materials, are governed by the
            content standards found within the Terms (“Content Standards”). You
            agree that your access and use of the Site will be in compliance
            with the Content Standards.
          </p>
          <p>
            You may use the Site only for lawful activities and in accordance
            with the Terms. You may not, and you agree that you will not,
            encourage, assist, or authorize the following prohibited activities
            on or through the Site:
          </p>
          <ul className="Identifiers">
            <li>
              using any device, robot, spider, script, automated or manual
              process, or other means to harvest information about, or “scrape”
              information about, other users or any Site content;
            </li>
            <li>
              interfering with the security of, or otherwise abusing, the Site
              or any system resources, services or networks connected to or
              accessible through the Site;
            </li>
            <li>
              taking any action that imposes an unreasonable or
              disproportionately large, as determined in the Company’s sole
              discretion, load on the Company’s hardware or software
              infrastructure;
            </li>
            <li>
              attempting to reverse engineer, decompile, disassemble, or
              otherwise obtain the source code to the Site;
            </li>
            <li>
              transmitting, installing, uploading or otherwise transferring any
              virus, malware, spam, phishing emails, or other item to the Site
              that in any way affects the use, enjoyment, or service of any user
              or any Company employee’s device used to access the Site;
            </li>
            <li>
              transmitting, installing, uploading, or otherwise transferring any
              materials to the Site that, in the Company’s sole discretion, are
              fraudulent, inaccurate, deceptive, defamatory, offensive, violent,
              lewd, salacious, explicit, discriminatory, illegal, infringing,
              hateful, inflammatory, obscene, pornographic, or sexually
              suggestive;
            </li>
            <li className="orange">
              transmitting, installing, uploading, or otherwise transferring any
              user-generated content or materials to the Site that are
              threatening, abusive or invade another’s privacy, cause annoyance,
              inconvenience or needless anxiety, harass, upset, embarrass, alarm
              or annoy any other person, impersonate any person, or misrepresent
              your identity or affiliation with any person is objectionable;
              There is no tolerance for objectionable content or abusive users
              per Apple's user-generated content standards. We will eject such
              content and offending user within 24 hours.
            </li>
            <li>
              transmitting, installing, uploading, or otherwise transferring to
              the Site any content that violates or infringes the intellectual
              property rights of others (including, but not limited to,
              copyrights, trademarks, trade secrets, patents, privacy rights,
              and/or publicity rights).
            </li>
            <li>engaging in or promoting any illegal activities;</li>
            <li>
              engaging in any activity that markets another business or attracts
              the Company’s customers to a third party;
            </li>
            <li>
              attempting to gain unauthorized access to password-protected,
              secure, or non-public areas of the Site, except with the written
              authorization of the Company;
            </li>
            <li>
              attempting to gain unauthorized access to another user’s Account
              on the Site; or
            </li>
            <li>
              otherwise attempting to interfere with the proper working of the
              Site.
            </li>
          </ul>
          <p>
            If you engage in any activity set forth above or violate any other
            terms herein, your Account shall be automatically terminated and
            your use of the Site will be prohibited. The Company may report any
            unlawful conduct to the appropriate authorities and may turn over
            any and all information regarding such activity to appropriate
            persons or entities.
          </p>

          <h5>PRIVACY</h5>
          <p>
            The Company respects and is committed to your privacy. Please review
            our Privacy Policy which describes our privacy practices and how we
            collect, use, and disclose personal information of users who use the
            Site.
          </p>
          <h5>MODIFICATIONS </h5>
          <p>
            We reserve the right at any time to change: (i) the Terms; (ii) the
            Site, including terminating, eliminating, supplementing, modifying,
            adding, or discontinuing any content or feature or data or service
            on or available through the Site or the hours that they are
            available; (iii) any fees or charges, if any, related to the use of
            the Site; and (iv) the equipment, hardware, or software required to
            use and access the Site.
          </p>
          <p>
            We reserve the right to change the Terms by posting revisions to the
            Site at any time. Any changes we make to the Terms will be effective
            immediately upon notice, which we may provide by any means
            including, without limitation, posting on the Site. Your continued
            use of the Site after such notice will be deemed acceptance of such
            changes. Accordingly, we urge you to review the Terms at the start
            of each use of the Site. It is your responsibility to check the Site
            regularly to determine if there have been changes to the Terms and
            to review such changes.
          </p>
          <h5>ACCURACY OF INFORMATION</h5>
          <p>
            The Company updates the information on the Site periodically.
            However, the Site may contain typographical errors or inaccuracies,
            and may not be complete or current. The Company cannot guarantee or
            accept any responsibility or liability for the accuracy, currency or
            completeness of the information on the Site. The Company therefore
            reserves the right to revise, supplement or delete any errors,
            inaccuracies, or omissions, and to change or update information at
            any time without prior notice to past, current or prospective users.
          </p>
          <h5>LINKED WEBSITES</h5>
          <p>
            The Site may contain links to third party websites, applications,
            materials, or resources, and are provided “as is.” These links are
            provided to you only as a convenience and their presence in the Site
            does not imply endorsement by the Company of such website or of any
            association with such websites’ operators. You should be aware that
            you use them at your own risk.
          </p>
          <p>
            We do not endorse, and will not be liable for, any content,
            products, services, software, or other materials available on such
            other websites, even if a page or pages of the other websites are
            framed within a page of the Site. We are not responsible for the
            privacy practices or the content of third party websites. For your
            protection, please refer to the terms of use and privacy policies of
            those respective websites.
          </p>
          <p>
            You acknowledge, understand, and agree that the Company shall not be
            responsible or liable, directly or indirectly, for any damage or
            loss caused or alleged to be caused by or in connection with use of,
            or reliance on, any such information, content, goods, or services
            available on or through such third party websites. We shall not be
            liable for any errors or delays in the content, goods, or services
            available on such third party websites, or for any actions taken or
            not taken in reliance thereon.
          </p>
          <h5>INTERNET SOFTWARE OR COMPUTER VIRUSES</h5>
          <p>
            Due to technical difficulties with the internet, internet software
            or transmission problems could produce inaccurate or incomplete
            copies of information contained on the Site. Due to the ability to
            share certain content and materials, computer viruses or other
            destructive programs may also be inadvertently downloaded from the
            Site.
          </p>
          <p>
            The Company shall not be responsible or liable for any software or
            computer viruses, or other destructive, harmful, or disruptive files
            or programs that may infect or otherwise impact your use of your
            computer equipment or other property on account of your access to,
            use of, or browsing on the Site, or your downloading the Site or any
            User Materials or other content from the Site. The Company
            recommends that you install appropriate anti-virus or other
            protective software.
          </p>
          <h5>DISCLAIMER OF WARRANTIES</h5>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE SITE, THE
            SERVICES, AND OTHER MATERIALS AVAILABLE ARE PROVIDED “AS IS,”
            WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED. THE COMPANY
            DOES NOT GUARANTEE, REPRESENT, OR WARRANT THAT YOUR USE OF THE SITE
            WILL BE SECURE, UNINTERRUPTED, ERROR FREE, OR VIRUS FREE, OR THAT
            THE SITE WILL MEET YOUR REQUIREMENTS. WE RESERVE THE RIGHT TO
            INTERRUPT/SUSPEND THE SITE, OR ANY PART THEREOF, WITH OR WITHOUT
            PRIOR NOTICE FOR ANY REASON AND YOU SHALL NOT BE ENTITLED TO ANY
            REFUNDS OF FEES, IF ANY, FOR INTERRUPTION OF THE SITE. INFORMATION
            OBTAINED THROUGH THE SITE HAS NOT BEEN VERIFIED, AND THE COMPANY
            DOES NOT GUARANTEE, REPRESENT OR WARRANT THAT SUCH INFORMATION IS
            ACCURATE, COMPLETE, RELIABLE, OR OTHERWISE VALID.
          </p>
          <p>
            THE COMPANY DOES NOT HAVE ANY OBLIGATION TO VERIFY THE IDENTITY OF
            THE PERSONS SUBSCRIBING TO THE SITE, NOR DOES IT HAVE ANY OBLIGATION
            TO MONITOR THE USE OF THE SITE BY OTHER USERS. THEREFORE, THE
            COMPANY DISCLAIMS ALL LIABILITY FOR INACCURATE INFORMATION, FRAUD,
            NEGLIGENCE, WILLFUL MISCONDUCT, OR ANY OTHER INAPPROPRIATE USE OF
            THE SITE.
          </p>
          <p>
            THE COMPANY DISCLAIMS ALL WARRANTIES, EXPRESS, OR IMPLIED,
            INCLUDING, BUT NOT LIMITED TO, ANY WARRANTY OF TITLE,
            NON-INFRINGEMENT, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
            OR ANY WARRANTY ARISING FROM A COURSE OF DEALING, TRADE USAGE, OR
            TRADE PRACTICE.
          </p>
          <p>
            SOME STATES AND JURISDICTIONS DO NOT ALLOW LIMITATIONS ON IMPLIED
            WARRANTIES, SO THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU. WHEN THE
            IMPLIED WARRANTIES ARE NOT ALLOWED TO BE EXCLUDED IN THEIR ENTIRETY,
            THEY WILL BE LIMITED TO THE SHORTEST DURATION PERMITTED BY LAW. YOU
            MAY ALSO HAVE OTHER RIGHTS WHICH VARY FROM STATE-TO-STATE.
          </p>
          <h5>LIMITATION OF LIABILITY</h5>
          <p>
            YOU ACKNOWLEDGE THAT YOU ARE 18 YEARS OF AGE OR OLDER. YOU
            ACKNOWLEDGE AND AGREE THAT USE OF THE SITE AND THE MATERIALS
            CONTAINED THEREIN IS AT YOUR SOLE RISK. YOU ACKNOWLEDGE THAT
            INFORMATION TRANSMITTED THROUGH THE INTERNET IS NEVER COMPLETELY
            SECURE. NEITHER THE COMPANY, NOR ANY OF THE COMPANY’S EMPLOYEES,
            AFFILIATES, AGENTS, REPRESENTATIVES, OR LICENSORS (COLLECTIVELY,
            “COMPANY ASSOCIATES”) SHALL BE LIABLE TO YOU OR ANY THIRD PARTY FOR
            ANY COMPENSATORY, DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,
            PUNITIVE, CONSEQUENTIAL, OR OTHER SIMILAR DAMAGES WHATSOEVER
            (INCLUDING DAMAGES FOR LOSS OF PROFITS, LOST DATA, INTERRUPTION,
            LOSS OF BUSINESS INFORMATION, OR ANY OTHER PECUNIARY LOSS), OR
            ATTORNEYS’ FEES ARISING UNDER OR OUT OF THE TERMS, OR OUT OF YOUR
            USE OF THE SITE OR INABILITY TO GAIN ACCESS TO OR TO USE THE SITE OR
            OUT OF ANY BREACH OF ANY WARRANTY, EVEN IF THE COMPANY OR A COMPANY
            ASSOCIATE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR IF
            SUCH DAMAGES WERE FORESEEABLE.
          </p>
          <p>
            YOUR SOLE RIGHT AND REMEDY WITH RESPECT TO ANY DISPUTE WITH THE
            COMPANY IS TO STOP USING THE SITE. BECAUSE SOME STATES OR
            JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY
            FOR CONSEQUENTIAL, INCIDENTAL OR SPECIAL DAMAGES, IN SUCH STATES AND
            JURISDICTIONS LIABILITY IS LIMITED TO THE GREATEST EXTENT PERMITTED
            BY LAW. IF THE FOREGOING LIMITATIONS ARE UNENFORCEABLE, YOU AGREE
            THAT THE COMPANY’S LIABILITY TO YOU UNDER THE TERMS SHALL NOT EXCEED
            FIVE U.S. DOLLARS AND NO CENTS ($5.00).
          </p>
          <p>
            THE SITE IS CONTROLLED, OPERATED, AND ADMINISTERED BY THE COMPANY
            FROM ITS OFFICES WITHIN THE UNITED STATES. THE COMPANY MAKES NO
            WARRANTY OR REPRESENTATION THAT MATERIAL AVAILABLE THROUGH THE SITE
            IS LEGAL, APPROPRIATE, OR AVAILABLE FOR USE OUTSIDE THE UNITED
            STATES. IF YOU ACCESS THE SITE FROM A LOCATION OUTSIDE THE UNITED
            STATES, YOU ARE RESPONSIBLE FOR COMPLIANCE WITH ALL APPLICABLE LAWS
            AND THE COMPANY ACCEPTS NO RESPONSIBILITY FOR SUCH ACCESS. WE
            RESERVE THE RIGHT TO LIMIT THE AVAILABILITY OF THE SITE, MATERIALS,
            OR OTHER PRODUCTS DESCRIBED IN THE TERMS TO ANY PERSON, GEOGRAPHIC
            AREA, OR JURISDICTION AS WE SO DESIRE, AT ANY TIME AND IN OUR SOLE
            DISCRETION, AND TO LIMIT THE QUANTITIES OF ANY SUCH SERVICES,
            MATERIALS OR OTHER PRODUCT PROVIDED.
          </p>
          <p>
            YOU ACKNOWLEDGE AND AGREE THAT ANY AND ALL DISCLAIMERS IN THE TERMS
            AND THE PROVISIONS OF THE TERMS REFLECT A FAIR AND REASONABLE
            ALLOCATION OF RISK BETWEEN THE COMPANY AND YOU.
          </p>
          <h5>INDEMNIFICATION</h5>
          <p>
            You agree to defend, indemnify, and hold harmless the Company and
            all Company Associates from and against, any and all liabilities,
            claims, costs, damages, demands, losses, and expenses, including all
            costs of legal proceedings and attorneys’ fees, arising directly or
            indirectly from, or related to: (i) any breach of the Terms for
            which you are responsible including, without limitation, your
            violation of any laws governing communications or intellectual
            property; (ii) any User Materials submitted by you or through your
            Account; and/or (iii) your use of the Site or transmission of any
            materials or other content through the Site.
          </p>
          <p>
            You agree to cooperate with us in asserting any available defenses.
            We reserve the right, at our own expense, to assume the exclusive
            defense and control of any matter otherwise subject to
            indemnification by you, and you shall not in any event settle any
            such matter without our prior written consent. This indemnification
            section will survive any termination or expiration of the Terms. We
            reserve the right to deny service to anyone, at any time, and for
            any reason or no reason, as permitted by law.
          </p>
          <h5>COPYRIGHT POLICY</h5>
          <p>
            We respect the intellectual property rights of others and expect
            users to do the same. In appropriate circumstances, and at our sole
            discretion, we may terminate and/or disable the accounts of users
            suspected to be infringing the copyrights (or other intellectual
            property rights) of others. Additionally, in appropriate
            circumstances, and in our sole discretion, we may remove or disable
            access to material on the Site that may be infringing or the subject
            of infringing activity.
          </p>
          <p>
            In accordance with the Digital Millennium Copyright Act of 1998,
            Title 17 of the United States Code, Section 512 (“DMCA”), we will
            respond promptly to claims of copyright infringement that are
            reported to the agent that we have designated to receive
            notifications of claims infringement (“Designated Agent”). Our
            Designated Agent can be reached at:
          </p>
          <p>
            Seize LLC Attn:
            <br /> DMCA Agent
            <br /> 16327 Piuma Ave, Cerritos, CA 90703
            <br /> Email:{" "}
            <a href="mailto:info@getpaths.com">info@getpaths.com</a>
            <br /> Phone: 360-693-4225
          </p>

          <p>
            If you are a copyright owner (or are authorized to act on behalf of
            a copyright owner) and believe that your copyright has been
            infringed, please report your notice of infringement to us by
            providing our Designated Agent with a written notification of
            claimed infringement that includes substantially the following:
          </p>
          <ul className="list">
            <li>
              A physical or electronic signature of a person authorized to act
              on behalf of the owner of an exclusive right that is allegedly
              infringed;
            </li>
            <li>
              Identification of the copyrighted work claimed to have been
              infringed, or, if multiple copyrighted works at a single online
              site are covered by a single notification, a representative list
              of such works at that site;
            </li>
            <li>
              Identification of the material that is claimed to be infringing or
              to be the subject of infringing activity and that is to be removed
              or access to which is to be disabled, and information reasonably
              sufficient to permit us to locate the material;
            </li>
            <li>
              Information reasonably sufficient to permit us to contact you,
              such as an address, telephone number, and, if available, an email
              address at which you may be contacted;
            </li>
            <li>
              A statement that you have a good faith belief that use of the
              material in the manner complained of is not authorized by the
              copyright owner, its agent, or the law; and
            </li>
            <li>
              A statement that the information in the notification is accurate,
              and under penalty of perjury, that you are authorized to act on
              behalf of the owner of an exclusive right that is allegedly
              infringed.
            </li>
          </ul>
          <p>
            We will investigate notices of copyright infringement and take
            appropriate actions under the DMCA. Inquiries that do not follow
            this procedure may not receive a response.
          </p>
          <h5>NOTICES</h5>
          <p>
            When required, you acknowledge that the Company may send you
            information or provide notice to you by a general posting on the
            Site, by email, by postal mail to your address of record, or through
            other means. If you have any questions about the Terms, the
            practices of the Site, or your dealings with the Company, please
            email or write to:
          </p>

          <p>
            Seize LLC
            <br /> Attn: Taber Nash
            <br /> 16327 Piuma Ave, Cerritos, CA 90703
            <br /> Email:{" "}
            <a href="mailto:Taber@getpaths.com">Taber@getpaths.com</a>
            <br /> <Link to="https://www.getpaths.com/">getpaths.com</Link>
          </p>
          <p>We welcome your questions and comments.</p>
          <h5>ACCESS RELATED TO ALLEGED VIOLATIONS</h5>
          <p>
            To ensure that we provide a high quality experience for you and
            other users of the Site, you agree that we may access your Account
            and all information and any records related thereto on a
            case-by-case basis to investigate complaints or allegations of
            abuse, infringement of third party rights, or other unauthorized
            uses of the Site, and you agree to give us full access to your
            Account and all information and records related thereto without the
            need for additional authorization and without any claim to privacy
            or other rights to such Account and related information and records.
          </p>
          <p>
            We do not intend to disclose the existence or occurrence of such an
            investigation unless required by law or if requested by law
            enforcement officials. However, the Company reserves the right to
            terminate your Account or your access to the Site immediately, with
            or without notice to you, and without liability to you, if we
            believe you have violated any of the Terms, furnished false or
            misleading information, or interfered with use of the Site by
            others.
          </p>
          <p>
            You acknowledge, consent, and agree that we may access, preserve,
            and disclose the information you provide if required to do so by law
            or in a good faith belief that such access preservation or
            disclosure is reasonably necessary to: (i) comply with legal
            process; (ii) enforce the Terms; (iii) respond to claims of a
            violation of the rights of third-parties; (iv) respond to your
            requests for customer service; or (v) protect the rights, property
            or personal safety of the Company, its users, and the public.
          </p>
          <h5>MISCELLANEOUS</h5>
          <p>
            The Site is provided for lawful purposes only. You acknowledge and
            agree that the provisions, disclosures, and disclaimers set forth in
            the Terms are fair and reasonable and your agreement to follow and
            be bound by them is not the result of fraud, duress, or undue
            influence exercised upon you by any person or entity. You
            acknowledge and agree that the Site is for your non-commercial use
            only.
          </p>
          <p>
            The Terms are governed by and construed in accordance with the laws
            of the State of Delaware and United States of America, without
            regard to their respective principles of conflicts of law. You agree
            to the exclusive jurisdiction and venue of the federal and state
            courts located in [COUNTY] County, Delaware, United States of
            America, in any matter arising from or related to the Terms and your
            use of the Site, and you waive any jurisdictional, venue, or
            inconvenient forum objections to such courts.
          </p>
          <p>
            If any provision of the Terms is found to be unlawful, void, or for
            any reason unenforceable, then that provision shall be deemed
            severable from the Terms and shall not affect the validity and
            enforceability of any remaining provisions.
          </p>
          <p>
            The Terms set out the entire agreement between us relating to the
            subject matter herein and supersede any and all prior or
            contemporaneous written or oral agreements between us. The Terms are
            not assignable, transferable, or sub-licensable by you, except with
            our prior written consent. The Terms provide only for the use of the
            Site. The Terms shall not be construed as a teaming, joint venture,
            or other such arrangement, unless the parties expressly and
            explicitly execute an agreement to that effect. No waiver by either
            party of any breach or default hereunder shall be deemed to be a
            waiver of any preceding or subsequent breach or default. Any
            heading, caption, or section title contained in the Terms is
            inserted only as a matter of convenience and in no way defines or
            explains any section or provision hereof.
          </p>
          <p>
            We shall have the right to assign the Terms and to sublicense any
            and all of the Company’s rights under the Terms. Notwithstanding any
            provision of the Terms, the Company has available all remedies at
            law or equity to enforce the Terms. The Company has no obligation to
            monitor the Site; however, you acknowledge and agree that we have
            the right to monitor the Site electronically from time to time and
            to disclose any information as necessary. You agree that we may
            terminate your use of the Site in our sole discretion for any reason
            or no reason.
          </p>
        </div>
      </PageLayout>
    </div>
  );
}
